import type { SVGProps } from "react";
export interface EmailHeartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function EmailHeartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: EmailHeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 11.38V5c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v10c0 1.036.84 1.875 1.875 1.875h5.052l.114.006a1.126 1.126 0 0 1 0 2.239l-.114.005H5a4.125 4.125 0 0 1-4.125-4.124V5A4.125 4.125 0 0 1 5 .875h14A4.125 4.125 0 0 1 23.125 5v6.38a1.126 1.126 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M19.957 13.876c.936 0 1.747.479 2.29 1.101.547.627.902 1.485.873 2.408l.002.002c-.037 1.226-.759 2.165-1.42 2.852l-.278.28c-.49.479-.96.923-1.365 1.3l-.98.897a1.614 1.614 0 0 1-2.04.096l-.118-.096a77 77 0 0 1-2.348-2.197c-.719-.703-1.656-1.731-1.698-3.132v-.002a3.52 3.52 0 0 1 .876-2.408c.543-.622 1.352-1.101 2.288-1.101.866 0 1.5.306 1.959.687.458-.382 1.093-.688 1.96-.688Zm0 2.25c-.294 0-.459.102-.587.228a1.4 1.4 0 0 0-.202.26l-.157.295v.002l-.03.05q-.008.02-.02.039a1 1 0 0 1-.181.223 1 1 0 0 1-.207.164l-.02.01q-.032.02-.065.037a1.1 1.1 0 0 1-.268.085 1.1 1.1 0 0 1-.445 0c-.047-.01-.093-.018-.14-.034l-.01-.003a1 1 0 0 1-.117-.048q-.034-.018-.066-.037l-.019-.01a1 1 0 0 1-.145-.106q-.028-.025-.055-.051a1.1 1.1 0 0 1-.194-.239l-.009-.016-.035-.064v-.002c-.097-.202-.2-.4-.357-.555-.128-.127-.294-.229-.589-.229-.148 0-.378.084-.593.331a1.3 1.3 0 0 0-.32.746l-.002.114v.003l.019.16c.073.38.372.814 1.003 1.431a74 74 0 0 0 1.852 1.743 74 74 0 0 0 1.853-1.743c.72-.705 1.01-1.17 1.022-1.59v-.004l-.003-.114a1.3 1.3 0 0 0-.32-.746c-.215-.247-.445-.33-.593-.33M20.875 5c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v.318c0 .319.174.612.453.766l7.519 4.135.215.101c.515.204 1.1.17 1.592-.1l7.518-4.136.1-.064a.87.87 0 0 0 .353-.702zm2.25.318c0 1.14-.62 2.189-1.62 2.738l-7.517 4.135a4.13 4.13 0 0 1-3.975 0l-7.52-4.135A3.13 3.13 0 0 1 .876 5.318V5A4.125 4.125 0 0 1 5 .875h14A4.125 4.125 0 0 1 23.125 5z"
      />
    </svg>
  );
}
